import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function Team() {
  const teamMembers = [
    {
      name: "Shubh Mehta",
      role: "Co-Founder & CEO",
      bio: "Visionary leader passionate about bringing authentic Gujarati cuisine to digital platforms. Coder King contributor.",
      icon: "👨‍💼",
    },
    {
      name: "Coder King",
      role: "Co-Founder & CTO",
      bio: "Full-stack developer focussed on building seamless user experiences and scalable backend infrastructure.",
      icon: "👨‍💻",
    },
    {
      name: "Operations Team",
      role: "Delivery & Logistics",
      bio: "Dedicated professionals ensuring every meal reaches you fresh and on time.",
      icon: "🚴",
    },
    {
      name: "Customer Care",
      role: "Customer Success",
      bio: "Available 7 AM to 11 PM to support your queries and enhance your experience.",
      icon: "🎧",
    },
  ];

  return (
    <div className="home">
      <Navbar />

      <div className="customer-page">
        <div className="customer-page-header">
          <h2>Meet Our Team</h2>
          <p>Dedicated people behind every order</p>
        </div>

        <section className="customer-card settings-section">
          <h3>Our Leadership</h3>
          <p>We're a small but mighty team committed to revolutionizing food delivery in Mumbai.</p>
        </section>

        <div className="team-grid">
          {teamMembers.map((member, idx) => (
            <article key={idx} className="team-member-card">
              <div className="member-icon">{member.icon}</div>
              <h3>{member.name}</h3>
              <p className="role">{member.role}</p>
              <p className="bio">{member.bio}</p>
            </article>
          ))}
        </div>

        <section className="customer-card settings-section">
          <h3>Join Our Team</h3>
          <p>
            We're always looking for passionate individuals to join us. If you're interested in being part of the 
            Shreeji Surti Swad journey, reach out to us at <strong>shreejisurtiswad@gmail.com</strong>
          </p>
          <div className="page-actions" style={{ marginTop: "1rem" }}>
            <button className="primary-action" onClick={() => window.location.href = "mailto:shreejisurtiswad@gmail.com"}>
              Send Email
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
